import React from "react";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/app/ui-bits";
import RecordInspector, { useRecordInspector } from "@/components/app/RecordInspector";
import ProjectQaCenter from "@/components/app/ProjectQaCenter";
import { ClipboardText, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, useFetchList } from "./_shared";

export default function NCRPanel({ project }) {
  const inspector = useRecordInspector();
  const { items, loading, err } = useFetchList(`/ncrs?project_id=${project.id}`, [project.id]);
  return (
    <div data-testid={`panel-ncr-${project.id}`}>
      <PanelHeader icon={ClipboardText} title="Non-Conformance Reports" subtitle="F-PM-15 · containment · RCA · CAPA"
        action={<ProjectQaCenter project={project} trigger={<Button size="sm" variant="outline">Manage <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {!loading && !err && items.length === 0 && <EmptyHint message="No NCRs raised on this project." />}
      {items.length > 0 && (
        <ul className="space-y-1.5">
          {items.slice(0, 20).map((r) => (
            <li key={r.id}
                onClick={() => inspector.open(r, { title: r.ncr_number || r.title || "NCR", subtitle: `${r.severity || "—"} · ${r.status || "—"}` })}
                data-testid={`ncr-row-${r.id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
              <span className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500 w-20 truncate">{r.ncr_number || "NCR"}</span>
              <span className="min-w-0 flex-1 truncate">{r.title || r.description || "Untitled"}</span>
              <StatusBadge status={r.status} />
            </li>
          ))}
        </ul>
      )}
      <RecordInspector {...inspector.props} />
    </div>
  );
}
